async function ItensPedido() {
  const dadosPedido = await JSON.parse(localStorage.getItem('itensPedido'))
  if (dadosPedido) return dadosPedido
  return {}
}

export default ItensPedido
